// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vme-statistic__card[data-v-2b80d450]{min-height:500px}.no-border[data-v-2b80d450]{border:none!important}.vme-statistic__iframe[data-v-2b80d450]{width:100%;height:100vh;border:0}", ""]);
// Exports
module.exports = exports;
